import { Controller } from 'react-hook-form'
import { useEffect } from 'react'
import { RadioGroup, TextField } from '../../../../components'
import { videoPlacementsOptions } from '../../../../utils/mappers'

interface Props {
  control: any
  errors: any
  watch: any
  register: any
  trigger: any
}

const SetVideoPlacements = ({
  control,
  errors,
  watch,
  register,
  trigger,
}: Props) => {
  const selectedPlacement = watch('videoPlacements')
  const selectedOtherValue = watch('videoPlacementsOther')

  // Trigger validation for text input when "other" is selected
  useEffect(() => {
    if (selectedPlacement === 'other') {
      trigger('videoPlacementsOther')
    }
  }, [selectedPlacement, trigger])

  // Trigger validation when text input value changes (works for both filled and empty)
  useEffect(() => {
    if (selectedPlacement === 'other') {
      trigger('videoPlacementsOther')
    }
  }, [selectedOtherValue, selectedPlacement, trigger])

  return (
    <div>
      <div className='mt-10 sm:mt-0'>
        <div className='md:grid md:grid-cols-3 md:gap-6'>
          <div className='md:col-span-1'>
            <div className=''>
              <h3 className='text-lg font-semibold font-sans leading-6 text-gray-900'>
                Where will you use these videos?
              </h3>
              <p className='mt-1 text-sm font-normal font-sans leading-5 text-gray-500'>
                Tell us where you'll use these videos so creators can match the
                style to each channel for native, better-performing content.
              </p>
            </div>
          </div>
          <div className='mt-5 md:col-span-2 md:mt-0'>
            <div className='md:shadow rounded-t-md sm:overflow-hidden'>
              <div className='py-5 md:bg-white space-y-6 sm:p-6'>
                <div className='grid gap-6'>
                  <div className='col-span-3 sm:col-span-2'>
                    <Controller
                      name='videoPlacements'
                      control={control}
                      rules={{
                        required:
                          'Please select where you will use these videos.',
                      }}
                      render={({ field }) => (
                        <RadioGroup
                          options={videoPlacementsOptions}
                          className='grid grid-cols-2'
                          field={field}
                          error={errors?.videoPlacements?.message}
                        />
                      )}
                    />

                    {selectedPlacement === 'other' && (
                      <div className='mt-4'>
                        <TextField
                          label='Please specify'
                          placeholder='Where will you use these videos?'
                          error={errors?.videoPlacementsOther?.message}
                          {...register('videoPlacementsOther', {
                            required:
                              selectedPlacement === 'other'
                                ? 'Please enter where you will use these videos.'
                                : false,
                            maxLength: {
                              value: 100,
                              message: 'Please use maximum 100 characters.',
                            },
                          })}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='hidden sm:block' aria-hidden='true'>
        <div className='py-5'>
          <div className='border-t border-gray-200' />
        </div>
      </div>
    </div>
  )
}

export { SetVideoPlacements }
